var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "menu-item",
      attrs: { to: _vm.path },
      nativeOn: {
        click: function ($event) {
          return _vm.handleClick.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "menu-link" }, [
        _vm._v("\n    " + _vm._s(_vm.text) + "\n  "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "menu-caption" }, [
        _vm._v("\n    " + _vm._s(_vm.caption) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }